<template>
  <div class="contaier">
    <div class="contaier2" @mouseleave="hover = false">
      <div class="nag-box_700" :class="{ 'nag-box_show700': tNvgShow }">
        <div class="nag" @click="goNewPage('/')" @mouseover="hover = false">
          {{ $t('homeP.home') }}
        </div>
        <div
          class="nag"
          @click="goNewPage('/about')"
          @mouseover="hover = false">
          {{ $t('homeP.about') }}
        </div>
        <div
          class="nag nag-models"
          @click="mouseoverFn"
          @mouseover="mouseoverFn">
          {{ $t('homeP.models') }}
        </div>
        <div
          class="nag"
          @click="goNewPage('/contact')"
          @mouseover="hover = false">
          {{ $t('homeP.contact') }}
        </div>
        <div
          class="nag"
          @click="goNewPage('/newsList')"
          @mouseover="hover = false">
          {{ $t('home.news') }}
        </div>
      </div>

      <i class="iconfont icon-danlieliebiao" @click="tNvgShow = !tNvgShow"></i>

      <div class="top-nvb_box">
        <div class="max-box top-nvb">
          <div class="logo-row">
            <div
              class="logo-box"
              @click="goNewPage('/')"
              @mouseover="hover = false"></div>

            <div class="nag-box" :class="{ 'nag-box_show': tNvgShow }">
              <div
                class="nag"
                @click="goNewPage('/')"
                @mouseover="hover = false">
                {{ $t('homeP.home') }}
              </div>
              <div
                class="nag"
                @click="goNewPage('/about')"
                @mouseover="hover = false">
                {{ $t('homeP.about') }}
              </div>
              <div class="nag nag-models" @mouseover="mouseoverFn">
                {{ $t('homeP.models') }}
              </div>
              <div
                class="nag"
                @click="goNewPage('/contact')"
                @mouseover="hover = false">
                {{ $t('homeP.contact') }}
              </div>
              <div
                class="nag"
                @click="goNewPage('/newsList')"
                @mouseover="hover = false">
                {{ $t('home.news') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="car-list" :class="{ 'car-list_ac': hover }">
        <div class="t-car">
          <i
            v-if="windowWidth <= 768"
            class="el-icon-circle-close"
            @click="hover = false"></i>

          <div
            class="t-car_item"
            @click="goNewPage2(item.id)"
            v-for="(item, index) in modelList"
            :key="item.id">
            <div class="img-box">
              <img class="c-img" alt="hongqi" :src="item.side_90" />
            </div>
            <div
              class="car-name"
              :class="{ 'car-name_ac': carIndex === index }">
              {{ item.modelName }}
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="dropdown-box"> -->
      <div class="dropdown-box" @click="changeLanguage()">
        <div class="nag nag-lang">
          <i class="iconfont icon--diqiu"></i>
          <span class="lang">{{ $t('home.lang') }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { throttle } from 'lodash'
// import { langMixins } from '@/mixins/langMixins'
import { imgBase } from '@/assets/js/static'
import { modelListApi } from '@/Api/requestApi'
import { EventBus } from '@/assets/js/event-bus'
export default {
  name: 'PageHeader',
  data() {
    return {
      tNvgShow: false,
      carIndex: -1,
      // hover: true,
      hover: false,
      windowWidth: 1680,
      modelList: [],
      scrollHandler:null
    }
  },
  mounted() {
    // console.log('this.$route :>>hhh ', this.$route);
    this.scrollHandler = throttle(this.handleResize, 200)
    window.addEventListener('resize', this.scrollHandler)
    this.handleResize()

    this.modelListFn()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.scrollHandler)
  },
  methods: {
    handleResize() {
      let ww_ = window.innerWidth
      // console.log('ww_ :>> ', ww_);
      // if (ww_ < 768) {
      //   this.paramH = '500px'
      // } else if (ww_ < 992) {
      //   this.paramH = '560px'
      // } else {
      //   this.paramH = '810px'
      // }

      // this.currentIndex = 0
      this.windowWidth = ww_
    },
    async modelListFn() {
      const {
        data: { code, data },
      } = await modelListApi({ state: 1 })
      if (code == 200) {
        let list_ = []
        console.log('data :>> ', data)
        for (let i = 0; i < data.length; i++) {
          // let exterior_ = []
          const { id, exterior, modelName } = data[i]
          let side_90 = ''
          for (let j = 0; j < exterior.length; j++) {
            const { front_90_side } = exterior[j]
            if (j === 0) {
              side_90 = `${imgBase}${front_90_side}?iopcmd=thumbnail&type=4&width=500&quality=60`
              break
            }
            // exterior_.push({
            //   id: j + 1,
            //   front_45_side: `${imgBase}${front_45_side}`,
            //   front_90_side: `${imgBase}${front_90_side}`,
            //   front_color: `${imgBase}${front_color}`,
            // })
          }
          list_.push({
            id,
            side_90,
            modelName,
            // exterior: exterior_,
            // imgKV: `${imgBase}${imgKV}`,
          })
        }
        // console.log('list_ :>> ', list_)
        this.modelList = list_
      }
    },
    goNewPage(p) {
      console.log('p :>>44 ', p)
      this.$router
        .push({ path: p, query: { lang: this.$i18n.locale } })
        .catch(() => {})
    },
    changeLanguage() {
      // console.log('changelang :>> ', lang)
      let lang_ = this.$i18n.locale === 'zh' ? 'en' : 'zh'

      this.$i18n.locale = lang_
      window.sessionStorage.setItem('sessionLang', lang_)
      window.scrollTo({ top: 0, behavior: 'smooth' });
      let query_ = { lang: lang_ }
      let id = this.$route.query?.id
      if (id) {
        query_.id = id
      }
      this.$router
        .push({ path: this.$route.path, query: query_ })
        .catch(() => {})
      EventBus.$emit('message', lang_)

      // this.$refs.formPageRef.changeLanguage(lang)
    },
    goNewPage2(id) {
      this.$router
        .push({
          path: '/carDetails',
          query: { id, lang: this.$i18n.locale },
        })
        .catch(() => {})
    },
    mouseoverFn() {
      // if (this.windowWidth < 768) {
      this.hover = true
      // }
    },
  },
}
</script>

<style lang="scss" scoped>
.img {
  object-fit: cover;
}
.contaier {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1999;

  .contaier2 {
    // width: 100%;
    // position: fixed;
    // left: 0;
    // top: 0;
    // z-index: 2008;
    // border-bottom: #ccc solid 1px;
    // background-color: #f3f3f3;
    border-bottom: #ccc solid 1px;
    background-color: #f3f3f3;
    position: relative;
    .nag-box_700 {
      display: none;
    }
    .icon-danlieliebiao {
      display: none;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 30px;
      color: #222;
    }
    .dropdown-box {
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translate(0%, -50%);
      // z-index: 99999999999;
    }
    .el-dropdown {
    }

    .nag-lang {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .lang {
        // font-weight: 600;
      }
      .icon--diqiu {
        font-size: 16px;
        font-weight: 600;
        padding-right: 5px;
      }
    }
  }
  .top-nvb_box {
    .top-nvb {
      margin: 0 auto;
      // padding: 20px 0;
      padding: 0 20px;
      // padding-top: 20px;
      text-align: right;

      .logo-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .logo-box {
          width: 80px;
          // margin: 10px 0;
          height: 80px;
          background-image: url('./../assets/img/logo.png');
          background-position: center;
          background-size: 100%;
          background-repeat: no-repeat;
          cursor: pointer;
        }

        .nag-box {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          padding-right: 80px;
          .nag {
            margin-left: 40px;
            // margin-left: 60px;
            line-height: 110px;
            cursor: pointer;
          }
          // .nag-models:hover {
          // color: #f00;
          // }
        }
      }
    }
  }
  .car-list {
    width: 100%;
    position: absolute;
    bottom: 0%;
    transform: translate(0%, -10%);
    transition: all 0.6s;
    z-index: -1;
    // box-shadow: 0px 7px 30px 0px rgba(100, 100, 111, 0.1);
    border-bottom: #666 solid 1px;
    .t-car {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 40px;
      padding-bottom: 40px;
      cursor: pointer;
      background-color: #f3f3f3;
      position: relative;
      .el-icon-circle-close {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 30px;
        color: #f00;
      }
      .t-car_item {
        flex: 1;
        max-width: 300px;
        margin: 0 40px;
        text-align: center;
        .img-box {
          aspect-ratio: 16 / 8;
          // background-color: red;
        }
        .car-name {
          width: 100px;
          margin: 0 auto;
          // padding-bottom: 1.4vw;
          padding-bottom: 10px;
          // border-bottom: solid 2px #fff;
        }
        // .car-name_ac {
        //   font-weight: 600;
        //   border-bottom: solid 2px #222;
        // }
      }
      .t-car_item:hover {
        // background-color: #fff;
        .car-name {
          font-weight: 600;
        }
      }
    }
  }
  .car-list_ac {
    transform: translate(0%, 100%);
    // background-color: red;
  }
}

@media (max-width: 768px) {
  .contaier {
    .contaier2 {
      .nag-box_700 {
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        transform: translate(0%, -50%);
        transition: all 0.6s;
        display: flex;
        flex-direction: column;
        transition: all 0.6s ease;
        background-color: #fff;
        box-shadow: 0px 7px 30px 0px rgba(100, 100, 111, 0.1);
        z-index: -1;
        .nag {
          width: 100%;
          margin: 0px;
          line-height: 60px;
          text-align: center;
          border-bottom: #f1f1f1 solid 1px;
        }
      }
      .nag-box_show700 {
        transform: translate(0%, 100%);
      }
      .icon-danlieliebiao {
        display: block;
        z-index: 1996;
      }
      .nag-lang {
        // color: #fff;
        .lang {
          // font-weight: 600;
        }
        .icon--diqiu {
        }
      }
    }

    .top-nvb_box {
      // background-color: #666;
      .top-nvb {
        position: relative;
        .logo-row {
          .logo-box {
            margin: 10px 0;
            width: 60px;
            height: 60px;
            background-image: url('./../assets/img/logo.png');
          }

          .nag-box {
            display: none;
          }
          .nag-box_show {
          }
        }

        .nag-lang {
          .icon--diqiu {
            // font-size: 20px;
            // color: #fff;
          }
          .lang {
            // padding-bottom:5px;
            // color: #fff;
          }
        }
      }
    }
    .car-list {
      .t-car {
        padding-top: 100px;
        padding-bottom: 60px;
      }
    }
  }
}
</style>
